
import {dateformat} from "@/api/date";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    // {
    //     prop: "income_collection_text",
    //     label: "收入类型",
    //     width: 75,
    // },
    // {
    //     prop: "ordersn",
    //     label: "关联单据",
    //     width: 75,
    // },
    {
        prop: "create_time_text",
        label: "创建时间",
        width: 75,
    },
    {
        prop: "toexamine",
        label: "状态",
        width: 65,
    },
    {
        prop: "income_price",
        label: "金额",
        width: 65,
    },
    {
        prop: "income_type_text",
        label: "收款方式",
        width: 75,
    },
    {
        prop: "income_payer",
        label: "付款方",
        width: 75,
    },
    {
        prop: "admin",
        label: "经手人",
        width: 75,
    },
    {
        prop: "income_desc",
        label: "备注",
        width: 75,
    },
];
const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList,
    getBasicsetList,
    getPurchaseExport,
    incomeListExport,
    permissionList,
    getBasicsetTotalList,
    getOrderCarOrderinfo,
} from "@/api/http";



import {Request} from '@/api/request';
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import { useRoute, useRouter } from 'vue-router'
import {ElLoading} from "element-plus";
export default defineComponent({
    name: "incomeList",
  setup: function () {
    const setTitle: any = inject("setTitle");
    setTitle(['收入记账']);

    const headClass = inject("headClass");
    let pageSize = ref(10),
        currentPage = ref(1),
        tableData = ref([] as Array<any>),
        total = ref(0),
        loading = ref(true),
        type = ref(''),
        roleList = ref({} as any),
        diatitle = ref(''),
        detailTable = ref([] as Array<any>),
        select_index = ref(0),
        route: any = useRoute(),
        Router: any = useRouter(),
    
        dialogFormVisible = ref(false),
        dialogTable = ref([] as Array<any>),
        orderDetail = ref({} as any),
        
        // 筛选
        selectGroup = reactive({
          status: "",
          build_bonus_price: "",
          return_cash_plan: "",
          mountings_type_pname: "",
          mountings_type_name: "",
          mountings_brand_name: "",
          search: ''
        }),
        selectList = ref({
          type: [],
          zf: [],
            specialType: [],
            specialZf: [],
          staff: [],
          income_type: [],
            totalPrice:null
        }),
        form_rules: any = {
          income_time: {required: true, message: '必填', trigger: 'blur'},
          income_type: {required: true, message: '必填', trigger: 'blur'},
          income_price: {required: true, message: '必填', trigger: 'blur'},
          income_collection: {required: true, message: '必填', trigger: 'blur'},
        },
        remote_loading = ref(false),
        getFirstNowLastDay = ():Array<number> => {
            let now = new Date();
            let strLink = "/";
            let year = now.getFullYear();
            let month:any = now.getMonth() + 1;
            let day:any = now.getDate();
            // if (month >= 1 && month <= 9) {
            //   month = "0" + month;
            // }
            // if (day >= 1 && day <= 9) {
            //   day = "0" + day;
            // }
            let firstDate:string = year + strLink + month + strLink + '1';
            let currentDate = year + strLink + month + strLink + day;
            //var lastDay = this.getLastDay(year, month);
            //var lastDate = year + strLink + month + strLink + lastDay;
            return [new Date(firstDate).getTime(),new Date(currentDate).getTime()];
        },
        screenParameter = ref({
          time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
          start_time: null,
          end_time: null,
          search: '',
          page: currentPage.value,
          pagesize: pageSize.value,
          type: 1,
          income_type: null,
          status: null,
          income_collection: null,
          store_id: null,
        } as any),
        dialog_model = ref(''),
        dialogTitle = ref("新增配件"),
        dialog_index = 0,
        dialog_load = ref(false),
        formRef = ref(null),
        form = ref({} as any),
        commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
        isEdit = ref(false),
        rules = reactive({
          name: [
            {
              required: true,
              validator: (
                  rule: any,
                  value: string,
                  callback: Function
              ) => {
                validateInput('请输入配件名称', value, callback);
              },
              trigger: "change",
            },
          ],
          class: [
            {
              required: true,
              validator: (
                  rule: any,
                  value: undefined,
                  callback: Function
              ) => {
                validateClass(rule, callback, form);
              },
              trigger: "change",
            },
          ],
          cost_price: [{required: true, message: '必填', trigger: "change"}],
          mountings_type_pid: [{required: true, message: '必填', trigger: "change"}],
          price: [
            {
              required: true,
              validator: (
                  rule: any,
                  value: string,
                  callback: Function
              ) => {
                validateInput('请输入成本价', value, callback);
              },
              trigger: "change",
            },
          ],
        });
    let handleSizeChange = (size: number): void => {
          pageSize.value = size;
          getTableData();
        },
        handleCurrentChange = (page: number): void => {
          currentPage.value = page;
          getTableData();
        },
        getTableData = (): void => {
          loading.value = true;
            let mydata = {
                type:1,
                role_name:'incomelist',
            };
            permissionList(mydata).then((res:any)=>{
                roleList.value = res?.content?.list || 0;
            });
            let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
            let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
          Request.axiosInstance({
            url: 'adminapi/Bookkeeping/incomeList',
            data: {
              ...screenParameter.value,
              page: currentPage.value,
              pagesize: pageSize.value,
                start_time:start_time,
                end_time:end_time
            }
          }).then((res: any) => {
            tableData.value = res?.content?.list || [];
            loading.value = false;
            total.value = res?.content?.total || 0;
              selectList.value.totalPrice = res?.content?.price_total;
          })

        },
        getSummariesDia = (param: any, type: number): Array<string> => {
            const {columns, data} = param;
            const sums: any = [];
            const propArr = [
                "othercosts_costprice",
                "price",
                "output_value",
                "pay_price",
            ];
            columns.forEach((column: any, index: number) => {
                if (index === 0) {
                    sums[index] = "";
                    return;
                }
                const values = data.map((item: any) =>
                    Number(item[column.property])
                );
                if (
                    propArr.findIndex((item: any) => {
                        return item == column.property;
                    }) > -1
                ) {
                    // 增加合计项
                    switch (type) {
                        // 维修项目报价合计
                        case 1:
                            if (column.property == "price") {
                                sums[index] = orderDetail.value.project_sum_quoted_price;
                            } else {
                                sums[index] = orderDetail.value.project_sum_output_value;
                            }
                            break;
                        // 配件报价合计
                        case 2:
                            if (column.property == "output_value") {
                                sums[index] = orderDetail.value.mountings_sum_output_value;
                            } else {
                                sums[index] = orderDetail.value.mountings_sum_quoted_price;
                            }
                        
                            break;
                        // 配件成本合计
                        case 3:
                            sums[index] = orderDetail.value.mountings_cost_price;
                            break;
                        // 其他成本合计
                        case 4:
                            sums[index] = orderDetail.value.else_cost_price;
                            break;
                        // 工单结算合计
                        case 5:
                            sums[index] = orderDetail.value.settlement_pirce;
                            break;
                    }
                    sums[index] = `¥${sums[index]}`;
                } else {
                    sums[index] = "";
                }
            });
            return sums;
        },
        // 点击单据编号触发
        getOrderCarinfo = (item: any) => {
            if (item.order_id<=0){
                return;
            }
            getOrderCarOrderinfo({order_id: item.order_id}).then((res: any) => {
                if (res.status == 200) {
                    dialogFormVisible.value = true;
                    let info = res.content.list;
                    if (info) {
                        let arr = [[
                            '单据编号',
                            info.ordersn,
                            '状态',
                            info.orderstatustext,
                            '开单时间',
                            info.create_time_text,
                            '结算时间',
                            info.settlement_time_text,
                        ], [
                            '服务类型',
                            info.basicset_id_name,
                            '接车人',
                            info.meet_vehicle_id_name,
                            '报价金额',
                            info.offer_price,
                            '结算金额',
                            info.settlement_pirce,
                        ], [
                            '车牌号码',
                            info.car_code,
                            '品牌车型',
                            info.series_name,
                            '进厂里程',
                            info.mitplant,
                            '是否返修',
                            info.is_rework_text,
                        ], [
                            '送修人',
                            info.send_for_repair,
                            '手机号码',
                            info.send_for_repair_phone,
                            '会员号',
                            info.user_id,
                            '昵称',
                            info.user_nickname,
                        ], [
                            '保险公司',
                            info.cicompany_id_name,
                            '送修单位',
                            info.units_id_name,
                            '合作方',
                            info.partner_id_name,
                            '工单备注',
                            info.settlement_notes,
                        ]];
                        dialogTable.value = arr;
                        orderDetail.value = res.content.list;
                    }
                }
            });
        },
        getSelectData = (data: {
          search?: string;
          type_pid?: number | null;
        }) => {
          getSelectList(data).then((res: any) => {
            Object.assign(selectList.value, res?.content || {});
            remote_loading.value = false;
          });
        },
        selectChange = (e: any, key: string): void => {
          // screenParameter[key] = e;
          // if(key == 'mountings_type_pid')
          // {
          //     screenParameter.value.mountings_type_id = null
          //     Request.axiosInstance({
          //         url: 'adminapi/MountingsType/list',
          //         data: {pid: screenParameter.value.mountings_type_pid}
          //     }).then((res: any) => {
          //          selectList.value.classificationb = res?.content?.list
          //     })
          //     return
          // }
          //getTableData();
            resetTableData();
        },
        remoteBrand = (e: string) => {
          remote_loading.value = true;
          getSelectData({search: e});
        },
        formSelectChange = (e: number) => {
          getSelectData({type_pid: e});
          form.value.mountings_type_id = null;
        },
        bonusSelectChange = (type: boolean) => {
          if (type) {
            form.value.build_bonus_price = null;
          } else {
            form.value.sell_bonus_price = null;
          }
        },
        changeIncome = (type: number, index: number) => {
          if (type == 1) {
            dialog_model.value = 'add';
            diatitle.value = '新增';
          } else {
            dialog_model.value = 'edit';
            diatitle.value = '修改';
            form.value = {
                income_id:Number(tableData.value[index].income_id),
              income_type: Number(tableData.value[index].income_type),
              income_time_text: tableData.value[index].income_time_text,
              income_time: tableData.value[index].income_time,
              income_price: tableData.value[index].income_price,
              income_collection: Number(tableData.value[index].income_collection),
              income_payer: tableData.value[index].income_payer,
              income_phone: tableData.value[index].income_phone,
              admin_id: tableData.value[index].admin_id,
              income_desc: tableData.value[index].income_desc
            };
          }

        },
        brandBlur = (type: boolean) => {
          if (type) {
            if (!selectGroup.mountings_brand_name) {
              getSelectData({});
            }
          } else {
            if (!form.value.mountings_brand_id) {
              getSelectData({});
            }
          }
        },
        detailClick = (index:number)=> {
          dialog_model.value = 'detail';
          dialog_index = index;
          let arr = [[
            '收入日期',
            tableData.value[dialog_index].income_time_text,
            '收入类型',
            tableData.value[dialog_index].income_collection_text,
            '类别',
            tableData.value[dialog_index].expenditure_type,
            '关联单据',
            tableData.value[dialog_index].ordersn,
          ],[
            '创建时间',
            tableData.value[dialog_index].create_time_text,
            '创建人',
            tableData.value[dialog_index].admin,
            '状态',
            tableData.value[dialog_index].toexamine,
            '审核时间',
            tableData.value[dialog_index].audit_time,
          ],[
            '审核人',
            tableData.value[dialog_index].admin,
            '金额',
            tableData.value[dialog_index].income_price,
            '收款方式',
            tableData.value[dialog_index].income_type_text,
            '付款方',
            tableData.value[dialog_index].income_payer,
          ],[
            '联系电话',
            tableData.value[dialog_index].income_phone,
            '经手人',
            tableData.value[dialog_index].admin,
            '备注',
            tableData.value[dialog_index].income_desc,
          ]];
          detailTable.value = arr;
        },
        screenChange = (e: any, key: string): void => {

          if (key == "time") {
              if (e){
                  //screenParameter.value["start_time"] = e ? (e[0] as Date).getTime() / 1000 : null
                  //screenParameter.value["end_time"] = e ? (e[1] as Date).getTime() / 1000 : null
              }else {
                  screenParameter.value["type"] = "";
              }
              currentPage.value = 1;
            getTableData();
          }
          if (key == 'formtime') {
            form.value["income_time_text"] = e
            form.value["income_time"] = e ? (e as Date).getTime() / 1000 : null
            console.log('-----', form.value["income_time"])
          }

        },
        columnChange = (
            item: partsFormType & { id: number; status: number },
            type: boolean
        ): void => {
          if (type) {
            dialogTitle.value = "编辑配件";
            isEdit.value = true;
            let data: any = {...form.value, id: 0};
            Object.keys(data).forEach((key) => {
              data[key as formKey] = item[key as formKey];
            });
            form.value = data;
            getSelectData({type_pid: form.value.mountings_type_pid});
          } else {
            getSetManagement({
              id: item.id,
              status: item.status == 1 ? 0 : 1,
            }).then((res) => getTableData());
          }
        },
        exportChange = () => {
          const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          });
            let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
            let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
            incomeListExport({
                ...screenParameter.value,
                start_time:start_time,
                end_time:end_time
            }).then((res: any) => {
            loading.close();
            const url = res.content;
            window.open(url);

          });
        },
        _form_submit = () => {
          (formRef.value as any).validate((valid: boolean) => {
            if (!valid) return
            dialog_load.value = true
              if (dialog_model.value == 'edit'){
                  Request.axiosInstance({
                      url: 'adminapi/Bookkeeping/editIncome',
                      data: form.value
                  }).then((res) => {
                      dialog_load.value = false
                      if (res.status != 202) return
                      dialog_model.value = ''
                      getTableData()
                  })
              }else {
                  Request.axiosInstance({
                      url: 'adminapi/Bookkeeping/createIncome',
                      data: form.value
                  }).then((res) => {
                      dialog_load.value = false
                      if (res.status != 202) return
                      dialog_model.value = ''
                      getTableData()
                  })
              }
            
          });
        },
        getSummaries = (param: any): Array<string> => {
            const {columns, data} = param;
            const sums: any = [];
            const propArr = [
                "income_price"
            ];
            columns.forEach((column: any, index: number) => {
                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }
                const values = data.map((item: any) =>
                    Number(item[column.property])
                );
                if (
                    propArr.findIndex((item: any) => {
                        return item == column.property;
                    }) > -1
                ) {
                    // 增加合计项
                    if (column.property == "income_price") {
                        sums[index] = selectList.value.totalPrice;
                    }
                } else {
                    sums[index] = "";
                }
            });
            return sums;
        },

        _option = (url: string, data: any) => {
          Router.push({
            path: url,
            query: data
          })
        },
        _purchaseMarkin = (id: number) => {
          Request.axiosInstance({
            url: 'adminapi/Warehouse/purchaseMarkin',
            data: {purchase_id: id}
          }).then((res: any) => {
            getTableData()
          })
        },
        resetTableData = (()=>{
            currentPage.value = 1;
            getTableData();
        }) ,
        _incomeUpstar = (id: Number, type: Number) => {

          Request.axiosInstance({
            url: 'adminapi/Bookkeeping/incomeUpstar',
            data: {income_id: id, type}
          }).then((res: any) => {
            res.status == 202 && getTableData()
          })

        }


    onMounted(() => {
      getBasicsetList({
        basicset_type: 4
      }).then((res: any) => {
        selectList.value.income_type = res.content?.list;
      }),

          Promise.all([
            Request.axiosInstance({
              url: 'adminapi/Bookkeeping/incomeTypeList',
              data: {status: 1}
            }),
            Request.axiosInstance({
              url: 'adminapi/Basicset/totalList',
              data: {basicset_type: 3}
            }),
            Request.axiosInstance({
              url: 'adminapi/OrderCar/constructors',
              data: {}
            }),
              Request.axiosInstance({
                  url: 'adminapi/Basicset/specialTotalList',
                  data: {basicset_type: 4}
              }),
              Request.axiosInstance({
                  url: 'adminapi/Basicset/specialTotalList',
                  data: {basicset_type: 3}
              }),

          ]).then((res: any) => {
            console.log(res)
            selectList.value.type = res[0]?.content?.list
            selectList.value.zf = res[1]?.content?.list
            selectList.value.staff = res[2]?.content?.staff
              selectList.value.specialType = res[3]?.content?.list
              selectList.value.specialZf = res[4]?.content?.list
          })


      getTableData();


    });

    watch(dialog_model, (newval: any, oldval: any) => {
      if (newval == 'add') {
        form.value = {
          income_time: new Date().getTime() / 1000,
            income_time_text: new Date(),
          income_type: null,
          income_price: null,
          income_collection: null,
          income_payer: null,
          income_phone: null,
          admin_id: null,
          income_desc: null
        }
        dialog_load.value = false;
        (formRef.value as any)?.resetFields();
      }

    })


    return {
      columnList,
        getSummaries,
      headClass,
      pageSize,
      currentPage,
      tableData,
      total,
      loading,
      selectGroup,
      selectList,
      remote_loading,
      dialogTitle,
      formRef,
      form,
      commissionType,
      isEdit,
      rules,
      handleSizeChange,
      handleCurrentChange,
      selectChange,
      remoteBrand,
      formSelectChange,
      bonusSelectChange,
      brandBlur,
      columnChange,
      type,
      _option,
      _purchaseMarkin,
      screenParameter,
      dialog_model,
      screenChange,
      _incomeUpstar,
      dialog_index,
      _form_submit,
      form_rules,
      dialog_load,
      diatitle,
      changeIncome,
      select_index,
      exportChange,
      detailTable,
      detailClick,
        roleList,
        resetTableData,
    
        dialogFormVisible,
        getOrderCarinfo,
        dialogTable,
        orderDetail,
        getSummariesDia,
        projectColumn,
        partsColumn,
        mountingsCostColumn,
        elseCostColumn,
        settlementColumn
    };
  },
});
